module.exports = __webpack_public_path__ + "images/cabecera.96f45bc6.png";